// @flow
import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import List from "@material-ui/core/List";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import CarIcon from '@material-ui/icons/DirectionsCar';
import PlaneIcon from '@material-ui/icons/Flight';
import ListIcon from '@material-ui/icons/List';
import AddIcon from '@material-ui/icons/Add';
import ChatIcon from '@material-ui/icons/Chat';
import makeStyles from "@material-ui/core/styles/makeStyles";
import NowFeeder from '../ui/NowFeeder';
import Header from '../Sidebar/Header';
import Messages from '../Messages';
import CarsContainer from './containers/CarsContainer';
import PlanesContainer from './containers/PlanesContainer';
import CarFormContainer from './containers/CarFormContainer';

const useStyles = makeStyles(theme => ({
    wrapper: {
        flexDirection: 'inherit'
    },
    labelIcon: {
        minHeight: 'inherit'
    },
    icon: {
        marginRight: '.5ch',
    }
}));

function Targets() {
    const classes = useStyles();

    const [type, setType] = useState('vehicles');
    const [subtype, setSubType] = useState('vehicles');

    const showVehicles = () => setSubType('vehicles');
    const handleChange = (event, newValue) => setType(newValue);
    const handleSubChange = (event, newValue) => setSubType(newValue);

    return (
        <List
            subheader={<Header
            title={<FormattedMessage
                id="sidebar.targets.header"
                defaultMessage="Targets"
            />}
        />}>

            <Tabs
                value={ type }
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
            >
                <Tab
                    classes={{ wrapper: classes.wrapper, labelIcon: classes.labelIcon }}
                    label={<FormattedMessage
                        id="targets.cars.vehicles"
                        defaultMessage="Vehicles"
                    />}
                    icon={<CarIcon className={classes.icon} />}
                    value="vehicles"
                />
                <Tab
                    classes={{ wrapper: classes.wrapper, labelIcon: classes.labelIcon }}
                    label={<FormattedMessage
                        id="targets.cars.aircrafts"
                        defaultMessage="Aircrafts"
                    />}
                    icon={<PlaneIcon className={classes.icon} />}
                    value="aircrafts"
                />
            </Tabs>

            {type === 'vehicles' && <React.Fragment>
                <BottomNavigation value={subtype} onChange={handleSubChange} showLabels={true}>
                    <BottomNavigationAction value="vehicles" label="Vehicles" icon={<ListIcon />} />
                    <BottomNavigationAction value="add-vehicle" label="Add Vehicle" icon={<AddIcon />} />
                    <BottomNavigationAction value="messages" label="Messages" icon={<ChatIcon />} />
                </BottomNavigation>

                {subtype === 'vehicles' &&
                    <NowFeeder>
                        {(now) => (
                            <CarsContainer now={now} />
                        )}
                    </NowFeeder>
                }

                {subtype === 'add-vehicle' &&
                    <CarFormContainer onClose={showVehicles}/>
                }

                {subtype === 'messages' &&
                    <Messages onClose={showVehicles} />
                }
            </React.Fragment>}

            {type === 'aircrafts' &&
                <PlanesContainer/>
            }
        </List>
    );
}

export default Targets;